// React Imports
import { useEffect, useState } from 'react'


const useMediaQuery = breakpoint => {
    const getMatches = () => {
        if (breakpoint === 'always') return true
        if (typeof window === 'undefined' || !breakpoint) return false
        return window.matchMedia(`(max-width: ${breakpoint})`).matches
    }

    const [matches, setMatches] = useState(getMatches)

    useEffect(() => {
        if (!breakpoint || breakpoint === 'always') return

        const media = window.matchMedia(`(max-width: ${breakpoint})`)

        const listener = (e) => setMatches(e.matches)

        media.addEventListener('change', listener)

        return () => media.removeEventListener('change', listener)
    }, [breakpoint])

    return matches
}

export default useMediaQuery
